const initialState = {
  position: { x: 0, y: 0 },
  active: false,
  activePlaylist: false,
  trackDataDialog: {},
  trackDataDialogPlaylist: {},
};

export default initialState;
